import { SMSRouteDefs } from "../../../routing/SMSRouteDefs";
import { IBLRouteDefs } from "./IBLRouteDefs";

export class IBLTaetigkeitsberichtRouteDefs {
  public static FEATURE_PATH = "taetigkeitsbericht";
  public static PARAM_ID = "Id";
  public static FKT_LIST_PATH = `home`;

  public static BASE_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}`;

  public static FKT_LIST_FQ_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.FKT_LIST_PATH}`;
  public static FQ_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}`;

  // Route for displaying IBL-Tätigkeitsbericht evaluations
  public static AUSWERTUNGEN_PATH = `auswertungen`;
  public static AUSWERTUNGEN_FQ_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.AUSWERTUNGEN_PATH}`;

  // Route for displaying relevant handbook chapter (placeholder, feature coming later)
  public static HANDBUCH_PATH = `handbuch`;
  public static HANDBUCH_FQ_PATH = `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.HANDBUCH_PATH}`;

  // Routes for Fristerstreckung
  public static FRISTERSTRECKUNG_CREATE_PATH = `f/fristerstreckung-create`;
  public static FRISTERSTRECKUNG_LIST_PATH = `f/fristerstreckung-list`;
  public static FRISTERSTRECKUNG_CREATE_FQ_PATH = `${this.BASE_PATH}/${this.FRISTERSTRECKUNG_CREATE_PATH}`;
  public static FRISTERSTRECKUNG_LIST_FQ_PATH = `${this.BASE_PATH}/${this.FRISTERSTRECKUNG_LIST_PATH}`;

  // Routes for report display (opened in new window)
  public static REPORT_TN_STAND_PATH = `report-tn-stand/:year/:integrativerBetrieb`;
  public static REPORT_LEHRBERUFE_PATH = `report-lehrberufe/:year/:integrativerBetrieb`;

  public static getFQRFKTList = () => this.FKT_LIST_FQ_PATH;

  public static getFQR = () => this.FQ_PATH;

  public static getAuswertungen = () => this.AUSWERTUNGEN_FQ_PATH;

  public static getHandbuch = () => this.HANDBUCH_FQ_PATH;

  public static getReportTnStand = (year: string, integrativerBetrieb: string) =>
    `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.REPORT_TN_STAND_PATH}`
      .replace(":year", year)
      .replace(":integrativerBetrieb", integrativerBetrieb);

  public static getReportLehrberufe = (year: string, integrativerBetrieb: string) =>
    `${SMSRouteDefs.FEATURE_PATH}/${IBLRouteDefs.FEATURE_PATH}/${this.FEATURE_PATH}/${this.REPORT_LEHRBERUFE_PATH}`
      .replace(":year", year)
      .replace(":integrativerBetrieb", integrativerBetrieb);

  public static getFristerstreckungCreate = () => this.FRISTERSTRECKUNG_CREATE_FQ_PATH;

  public static getFristerstreckungList = () => this.FRISTERSTRECKUNG_LIST_FQ_PATH;
}
